module.exports = __webpack_public_path__ + "static/img/274_TO8_2399_og.67b2006.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/274_TO8_2399_og.jpg
// module id = pERw
// module chunks = 0